import { defineAsyncComponent } from 'vue'
export default {
  dashboard: defineAsyncComponent(() => import("C:/laragon/www/pergiyuks-frontend/layouts/dashboard.vue").then(m => m.default || m))
}